import axios from 'axios';

const taskApi = {
  async getTasks() {
    const response = await axios.get('/api/tenant/task');
    return response.data;
  },
  async getTask(id) {
    const response = await axios.get(`/api/tenant/task/${id}`);
    return response.data;
  },
  async createTask(task) {
    const response = await axios.post('/api/tenant/task', task);
    return response.data;
  },
  async updateTask(task) {
    const response = await axios.put(`/api/tenant/task/${task.id}`, task);
    return response.data;
  },
  async deleteTask(id) {
    const response = await axios.delete(`/api/tenant/task/${id}`);
    return response.data;
  },

};

export default taskApi;
